import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { IFront } from 'src/app/modules/widget/interfaces/front';
import { IFilter } from '../../../interfaces/filter-config';
import { FilterHandlerService } from '../../../services/filter/filter-handler.service';
import { GoogleAnalyticsService } from '../../../services/google/google-analytics.service';

@Component({
  selector: 'filter-front',
  templateUrl: './filter-front.component.html',
  styleUrls: ['./filter-front.component.scss'],
})
export class FilterFrontComponent implements AfterViewInit {
  @Input() public filter: IFilter;

  @Input() public allFronts: IFront[];

  @Input() public set zone(zone: string) {
    if (zone !== undefined) {
      this.getFrontsByZone(String(zone));
    }
  }

  @Output() public frontsChanged: EventEmitter<IFront[]>;

  public fronts: IFront[];

  public selectedOption: any;

  constructor(
    private filterHandlerService: FilterHandlerService,
    private cdr: ChangeDetectorRef,
    private googleAnalyticsService: GoogleAnalyticsService,
  ) {
    this.fronts = [];
    this.frontsChanged = new EventEmitter<IFront[]>();
  }

  /**
   * App after view init
   */
  public ngAfterViewInit(): void {
    this.filterHandlerService.clearFilter$.subscribe(() => {
      this.selectedOption = null;
    });
  }

  /**
   * Function to change selected front
   *
   * @param $event selected front
   */
  public changeSelectedOption($event: IFront[]): void {
    this.frontsChanged.emit($event);
    this.selectedOption = $event;
    const filter = {
      filter_selected: 'filter_front',
      value_selected: $event,
    };
    this.googleAnalyticsService.sendFilterEvent(filter);
  }

  /**
   * Function to get fronts by front
   *
   * @param front Incoming front
   */
  public getFrontsByZone(zone: string): void {
    if (zone.length > 0) {
      const zones = String(zone).split('|');
      const fronts = [];

      for (const item of zones) {
        const array = this.allFronts.filter((v) => String(v.zoneId) === String(item));
        fronts.push(...array);
      }

      if (this.filter.multiselect) {
        for (const front of fronts) {
          front.selectedAllGroup = 'selectedAllGroup';
        }
      }

      this.fronts = fronts;
    } else {
      this.fronts = null;
    }

    this.cdr.detectChanges();
  }
}
